<template>
    <div class="container">
        <LoadingBlock v-if="!hasApplianceType && isLoading"/>
        <RouterView v-if="hasApplianceType"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import LoadingBlock from "../../Common/UI/LoadingBlock.vue"

export default {

    components: {
        LoadingBlock,
    },

    computed: {
        ...mapGetters({
            isLoading: 'appliance/types/isLoading',
            hasApplianceType: 'appliance/types/hasType',
            applianceType: 'appliance/types/getType',
        }),
    },

    created() {
        this.$store.dispatch("appliance/types/clear")
        this.loadApplianceType(this.$route.params.id)
    },

    methods: {

        loadApplianceType(id) {
            this.$store.dispatch("appliance/types/getType", id)
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
        },

    },

}
</script>
